import { db } from '../../firebase/config';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { createDefaultUserDatabase } from './initializeUserDatabase';

// Add user to Firestore if not exist
export async function addUserToDictionary(user) {
  if (!user) return;

  const userRef = doc(db, 'users', user.uid);
  const userSnap = await getDoc(userRef);

  if (!userSnap.exists()) {
    await setDoc(userRef, createDefaultUserDatabase(user));
  }
}
